var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"async-text-loading\" ng-transclude=\"loading\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"async-text-initial\" ng-transclude=\"initial\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/application/directive/async/async.tpl.pug
// module id = IJ/B
// module chunks = 0